// extracted by mini-css-extract-plugin
module.exports = {"root":"DateLabel_root__yQCsf","upcoming":"DateLabel_upcoming__3BsgC","completed":"DateLabel_completed__3hpho"};